import { Dropdown, Form, FormField } from 'semantic-ui-react'
import { useQuery } from '@tanstack/react-query'
import { getMerchantsOfCompany, getPointOfSalesInScope } from '../../../../services/Company/Company.service'
import { isProviderACompany } from '../../../../services/Provider/Provider.service'
import useUser from '../../UserProvider/useUser'
import useFilters from '../useFilters'
import { useTranslation } from 'react-i18next'

const MultiPosFilter = () => {
    const [t] = useTranslation();
    const { user } = useUser()
    const { filters, setFilters } = useFilters()
    const { data: pointOfSales, isLoading, isSuccess } = useQuery({
        queryKey: ['pointofsales'],
        queryFn: () => {
            if (user.isLoggedInOwnScope) {
                return getPointOfSalesInScope(user.providers)
            }

            return getMerchantsOfCompany(isProviderACompany(user.provider) ? user.provider.object.id : user.provider.object.company.id)
        },
        select: (data) => data.sort((a, b) => a.name.localeCompare(b.name)),
    })

    return (
      <Form>
          <FormField>
              <label>{t('global.merchants')}</label>
              <Dropdown
                clearable
                fluid
                selection
                multiple
                search
                loading={isLoading}
                options={pointOfSales?.map(pos => ({
                    key: pos.id,
                    value: pos.id,
                    text: pos.name,
                })) || []}
                onChange={(e, { value }) => {
                    setFilters({...filters, posIds: value})
                }}
                value={filters.posIds}
              />
          </FormField>
      </Form>
    )
}

export { MultiPosFilter }
